import { useContext } from 'react';

import { CookieContext, CookieContextProps } from './CookieConsent';
import { applyServices, setAllServices, setService } from './utils';

export const useCookieConsent = () => {
  const context = useContext(CookieContext) as CookieContextProps;

  const isEnabled = (service: string) => context?.services && context.services[service];
  const revoke = (servicesToSet: string | string[]) => setService(servicesToSet, context, false);
  const accept = (servicesToSet: string | string[]) => setService(servicesToSet, context, true);
  const acceptAll = () => {
    setAllServices(context, true);
    context.setConsentGiven(true);
  };
  const revokeAll = () => {
    setAllServices(context, false);
    context.setConsentGiven(true);
  };
  const apply = (servicesToApply: Record<string, boolean>) => applyServices(servicesToApply, context);
  const openManager = () => context.setShowManager(true);
  const closeManager = () => context.setShowManager(false);
  const giveConsent = () => context.setConsentGiven(true);

  return {
    services: context?.services,
    isEnabled,
    accept,
    revoke,
    acceptAll,
    revokeAll,
    apply,
    showManager: context?.showManager,
    openManager,
    closeManager,
    // TODO: rename this to something more meaningful
    needsConsent: !context?.consentGiven,
    giveConsent,
    locale: context?.locale,
  };
};
